import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useGetTheme } from '../../../../../hooks/use-get-theme';
import { useSetDocumentDescription } from '../../../../../hooks/use-set-document-description';
import { useFetchIssuerDotcmsContentWithDefaultFallback } from '../../../../../dotcms/use-fetch-from-dotcms-with-default-fallback';
import { HomePageGqlHelper } from '../../../../../dotcms/dotcms-models/dotcms-home-page';
import { useBuildersToProcessGqlData } from '../../../../../dotcms/use-builders-to-process-gql-data';
import { GlobalLoadingStateOperation } from '../../../global-loading-context/global-loading-context';
import { useGetPageConditionRequirementResults } from '../../../../../app/pages-requiring-condition';
import { Page } from '../../../../../app/page-url-path';
import usePlanIsEsppOnly from '../../../../../hooks/use-is-espp-only/use-plan-is-espp-only';

const useHomepage = () => {
  const theme = useGetTheme();
  const muiTheme = useTheme();
  const defaultDocumentDescription =
    'Equitable stock ownership for the world’s workforce.';
  const planIsEsppOnly = usePlanIsEsppOnly();
  const setDocumentDescription = useSetDocumentDescription();

  const isCashlessPageAvailable =
    useGetPageConditionRequirementResults()[Page.ABOUT_CASHLESS];

  const { createGqlQueryForSingle, processGqlDataAsSingle, contentTypeName } =
    useBuildersToProcessGqlData(HomePageGqlHelper);
  const { data, loading, error } =
    useFetchIssuerDotcmsContentWithDefaultFallback({
      buildGqlSubQuery: createGqlQueryForSingle,
      processResponse: processGqlDataAsSingle,
      loadingStateOperationName:
        GlobalLoadingStateOperation.HOMEPAGE_DOTCMS_FETCH,
      contentTypeName,
    });

  return useMemo(
    () => ({
      theme,
      muiTheme,
      data,
      loading,
      error,
      defaultDocumentDescription,
      setDocumentDescription,
      isCashlessPageAvailable,
      planIsEsppOnly,
    }),
    [
      theme,
      muiTheme,
      data,
      error,
      loading,
      defaultDocumentDescription,
      setDocumentDescription,
      isCashlessPageAvailable,
      planIsEsppOnly,
    ],
  );
};

export default useHomepage;
